// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import {Dictionary} from '../../../shared/models/dictionary.model';
import {IBaseType} from '../../../shared/enums/ibase-type.enum';

export interface INmvtisFindingType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class NmvtisFindingType implements INmvtisFindingType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Moped RegistrationType
	**/
    get CustomerPresentedPoliceReport(): INmvtisFindingType {
        return this.FromId(1);
    }
    /**
		Returns Arizona Registration Only RegistrationType
	**/
    get Issuingaduplicatetitle(): INmvtisFindingType {
        return this.FromId(2);
    }
    /**
		Returns SPI RegistrationType
	**/
    get OktoprocessperLocalLawEnforcement(): INmvtisFindingType {
        return this.FromId(3);
    }
    /**
		Returns Regular RegistrationType
	**/
    get OktoprocessperMVDEnforcement(): INmvtisFindingType {
        return this.FromId(4);
    }

    get OktoprocessperReportingAgency(): INmvtisFindingType {
        return this.FromId(5);
    }

    get Recordaccessedinerror(): INmvtisFindingType {
        return this.FromId(6);
    }

    get Stolenpartisamajorcomponentpart(): INmvtisFindingType {
        return this.FromId(7);
    }

    get Stolenpartnotamajorcomponentpart(): INmvtisFindingType {
        return this.FromId(8);
    }

    get Vehicleconfirmedstolen(): INmvtisFindingType {
        return this.FromId(9);
    }

    get Vehicleinbondprocess(): INmvtisFindingType {
        return this.FromId(10);
    }

    get VINplatemissing(): INmvtisFindingType {
        return this.FromId(11);
    }

    get VINMakeorYeardidnotmatchnotthesamevehicle(): INmvtisFindingType {
        return this.FromId(12);
    }

    get VINMakeorYearenteredincorrectly(): INmvtisFindingType {
        return this.FromId(13);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'CustomerPresentedPoliceReport', displayValue: 'Customer presented police report', description: 'Customer presented police report', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'Issuingaduplicatetitle', displayValue: 'Issuing a duplicate title', description: 'Issuing a duplicate title', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, value: 'OktoprocessperLocalLawEnforcement', displayValue: 'Ok to process per Local LE', description: 'Ok to process per Local LE', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, value: 'OktoprocessperMVDEnforcement', displayValue: 'Ok to process per MVD Enforcement', description: 'Ok to process per MVD Enforcement', sortOrder: 4, active: true });
        this._dictionary.add('5', { id: 5, value: 'OktoprocessperReportingAgency', displayValue: 'Ok to process per Reporting Agency', description: 'Ok to process per Reporting Agency', sortOrder: 5, active: true });
        this._dictionary.add('6', { id: 6, value: 'Recordaccessedinerror', displayValue: 'Record accessed in error', description: 'Record accessed in error', sortOrder: 6, active: true });
        this._dictionary.add('7', { id: 7, value: 'Stolenpartisamajorcomponentpart', displayValue: 'Stolen part is a major component part', description: 'Stolen part is a major component part', sortOrder: 7, active: true });
        this._dictionary.add('8', { id: 8, value: 'Stolenpartnotamajorcomponentpart', displayValue: 'Stolen part not a major component part', description: 'Stolen part not a major component part', sortOrder: 8, active: true });
        this._dictionary.add('9', { id: 9, value: 'Vehicleconfirmedstolen', displayValue: 'Vehicle confirmed stolen', description: 'Vehicle confirmed stolen', sortOrder: 9, active: true });
        this._dictionary.add('10', { id: 10, value: 'Vehicleinbondprocess', displayValue: 'Vehicle in bond process', description: 'Vehicle in bond process', sortOrder: 10, active: true });
        this._dictionary.add('11', { id: 11, value: 'VINplatemissing', displayValue: 'VIN plate missing', description: 'VIN plate missing', sortOrder: 11, active: true });
        this._dictionary.add('12', { id: 12, value: 'VINMakeorYeardidnotmatchnotthesamevehicle', displayValue: 'VIN, Make or Year did not match, not the same vehicle', description: 'VIN, Make or Year did not match, not the same vehicle', sortOrder: 12, active: true });
        this._dictionary.add('13', { id: 13, value: 'VINMakeorYearenteredincorrectly', displayValue: 'VIN, Make or Year entered incorrectly', description: 'VIN, Make or Year entered incorrectly', sortOrder: 13, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): INmvtisFindingType {
        return this._dictionary[id];
    }

    public FromValue(value: string): INmvtisFindingType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): INmvtisFindingType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): INmvtisFindingType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): INmvtisFindingType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
